<template>
  <div>
    <Modal title="Tem certeza que deseja cancelar?" :width="600" v-show="showModal('cancelNfse')">
      <Alert type="warning">
        <span>
          Atenção, ao cancelar uma Nota Fiscal alguns processos (se houver) serão executados, certifique-se que está
          cancelando a Nota correta, esta ação é irreversível...
        </span>
      </Alert>
      <div>
        <i class="fa-solid fa-circle-xmark icon-close"></i> Nota Fiscal ficará com status de Cancelada
      </div>
      <div>
        <i class="fa-solid fa-circle-xmark icon-close"></i> Pagamentos vinculados serão excluídos
      </div>
      <div>
        <i class="fa-solid fa-circle-xmark icon-close"></i> Boletos emitidos serão baixados ou excluídos
      </div>
      <div>
        <i class="fa-solid fa-triangle-exclamation icon-warning"></i> Produtos da Locação serão liberados
        para novo Faturamento
      </div>
      <Confirmation :isModal="false" title="Você tem certeza?" type="danger" :confirmed="cancel" />
    </Modal>
  </div>
</template>
<script>
import Confirmation from "@nixweb/nixloc-ui/src/component/shared/Confirmation.vue";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations, mapActions, mapState } from "vuex";

export default {
  name: "CancelNfse",
  components: {
    Confirmation,
    Alert,
    Modal,
    Button,
  },
  data() {
    return {
      id: "",
      urlCancelAllApi: "/api/v1/tax-document/nfse/cancel",
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("generic", ["selected"]),
  },
  methods: {
    ...mapMutations("generic", [
      "openModal",
      "hideModal",
      "removeLoading",
      "addEvent",
    ]),
    ...mapActions("generic", ["deleteAllApi"]),
    cancel() {
      let params = {
        url: this.urlCancelAllApi,
        selected: [this.id],
      };

      this.deleteAllApi(params).then((response) => {
        if (response.success) {
          this.hideModal("cancelNfse");
          this.addEvent({ name: "canceledNfse" });
        }
        this.removeLoading(["confirm"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "cancelNfse") {
          this.id = event.data.idIntegracao;
          this.openModal("cancelNfse");
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.icon-close {
  color: red;
}

.icon-warning {
  color: darkorange;
}
</style>